import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { SearchZeroResultsHelp } from './SearchZeroResultsHelp';
import {
  ZeroResultsContainer,
  ZeroResultsMain,
  ZeroResultsTitle,
} from './ZeroDecisionLib';
import { SearchTypes } from '../../search.types';

const LABEL_TYPE_MAP = {
  commentary: 'search/zero-results/ZeroCommonResults.tsx/1',
  law: 'search/zero-results/ZeroCommonResults.tsx/2',
  lawyer: 'search/zero-results/ZeroCommonResults.tsx/3',
  enterprise: 'search/zero-results/ZeroCommonResults.tsx/4',
  preparatory_work: 'search/zero-results/ZeroCommonResults.tsx/5',
} as const;

type Props = {
  searchType: Exclude<SearchTypes, 'arret'>;
};

export const ZeroCommonResults: FC<Props> = ({ searchType }) => (
  <ZeroResultsContainer data-test-id="zero-common">
    <ZeroResultsMain>
      <ZeroResultsTitle>
        <FormattedMessage id={LABEL_TYPE_MAP[searchType]} />
      </ZeroResultsTitle>
      <SearchZeroResultsHelp searchType={searchType} />
    </ZeroResultsMain>
  </ZeroResultsContainer>
);
